import { render } from "./VSelectDeselect.vue?vue&type=template&id=bb6cddb4"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/VSelectDeselect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb6cddb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb6cddb4', __exports__)) {
    api.reload('bb6cddb4', __exports__)
  }
  
  module.hot.accept("./VSelectDeselect.vue?vue&type=template&id=bb6cddb4", () => {
    api.rerender('bb6cddb4', render)
  })

}


export default __exports__